import { Calendar } from './Calendar';

export class Restaurant {
    id: number;
    name: string;
    distance: number;
    state: string;
    city: string;
    streetaddress: string;
    streetaddress2?: string;
    zip: string;
    candeliver: boolean;
    supportscurbside: boolean;
    supportsdispatch?: boolean;
    supportsdinein: boolean;
    acceptsordersbeforeopening: boolean;
    canpickup: boolean;
    calendar: Array<Calendar>;
    calendars?: Array<Calendar>;
    telephone: string;
    supportssplitpayments: boolean;
    url: string;
    brand: string;
    latitude: number;
    longitude: number;
    supportedtimemodes: Array<string>;
    extref: string;
    isavailable: boolean;
    slug: string;
    customerfacingmessage: string;
    utcoffset: number;
    allowstaxexemption?: boolean;

    constructor(init?: Partial<Restaurant>) {
        Object.assign(this, init);
    }

    public static Make(obj: any): Restaurant {
        const restaurant = new Restaurant();
        Object.assign(restaurant, obj);
        return restaurant;
    }

    public static AddressLink(restaurant: Restaurant) {
        const param =
            `${restaurant.streetaddress}, ${restaurant.city}, ${restaurant.state}, ${restaurant.zip}`.replaceAll(
                ' ',
                '+'
            );
        return `https://google.com/maps?daddr=${param}`;
    }
}
